export default __webpack_public_path__ + "static/media/cover-3.0486be77.jpg";